export const eventMap: {[index: string]: "click"
| "double-click"
| "drag"
| "hold"
| "key-down"
| "key-up"
| "layerview-create"
| "layerview-destroy"
| "mouse-wheel"
| "pointer-down"
| "pointer-move"
| "pointer-up"
| "resize";
} = {
    onClick: "click",
    onDoubleClick: "double-click",
    onDrag: "drag",
    onHold: "hold",
    onKeyDown: "key-down",
    onKeyUp: "key-up",
    onLayerViewCreate: "layerview-create",
    onLayerViewDestroy: "layerview-destroy",
    onMouseWheel: "mouse-wheel",
    onPointerDown: "pointer-down",
    onPointerMove: "pointer-move",
    onPointerUp: "pointer-up",
    onResize: "resize"
};
